import React from 'react'
import logoLogin from "../image/logo_main.png";
import { FaWhatsapp } from 'react-icons/fa';
import { Button } from "react-bootstrap"
import useWindowDimensions from '../helpers/useWindowDimensions';


export default function CustomNavbar({phone}) {
    const { width, height } = useWindowDimensions()


    const contactToShop = () => {
        // console.log("log phone:--->", data)
        const phoneNumber = "+856020" + phone;
    
        // You can also include a message using the 'text' parameter.
        const message = "ສະບາຍດີ🙏";
    
        // Construct the WhatsApp URL using https://wa.me.
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
          message
        )}`;
    
        // Open WhatsApp using the constructed URL.
        // window.open(whatsappUrl);
        window.location.href = whatsappUrl;
      };


    return (
        <div style={{padding:'0 5px', display:'flex', position:'fixed', left:0,top:0,justifyContent:'space-between',width:'100%', alignItems:'center', background:"#ffffff"}}>
            <div style={{ padding: 10 }} className="d-flex gap-2 justify-content-start align-items-center">
                <div
                    style={{
                        width: 40,
                        height: 40,
                        overflow: "hidden",
                        display: "flex",
                        gap: 2,
                    }}
                >
                    <img
                        style={{ width: "100%", height: "100%" }}
                        src={logoLogin}
                    />
                </div>
                {width > 700 &&
                <h5 style={{ fontWeight: 'bold', fontSize: 23 }}>
                    ລະບົບດູດຄອມເມັ້ນຂອງຄົນລາວ
                </h5>
                }
            </div>

            <Button variant='outline-success' onClick={() => contactToShop()}>
                <FaWhatsapp style={{fontSize:30, marginRight:3}} /> ຕິດຕໍ່ຮ້ານ
            {/* +856 020 59141424 */}
            </Button>
        </div>
    )
}
